import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
// import store from "../..";

const state = {
  taxs: [],
};
const getters = {
  taxsListGet: (state) => state.taxs,
};
const actions = {
  async getAllTaxs({ commit }) {
    await service.getFun(`taxs`).then(
      (response) => {
        let result = response.data;
        commit("setTaxs", result);
        console.log("taxs", result);
      },
      (error) => {
        console.log(error);
      }
    );
  },

  async addTaxSlice({ commit }, payload) {
    const res = await service.postFun(payload, "taxs", null, {
      action: "getAllTaxs",
    });
    if (res?.data) {
      commit("setAddTaxSlice", res?.success);
      commit("setTaxSliceErrors", []);
      toast("success");
    } else {
      commit("setSliceErrors", res);
    }
  },

  editTaxSlice({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `taxs/${payload.id}`, null, {
        action: "getAllTaxs",
      })
      .then((result) => {
        commit("setEditTaxSlice", result.success);
        toast(result.message);
      });
  },
  deleteTaxSlice({ commit }, payload) {
    console.log("delete", payload);
    service
      .deleteFun(`taxs/${payload.payload}`, {
        action: "getAllTaxs",
      })
      .then(
        (result) => {
          commit("deleteTaxSlice", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};

const mutations = {
  setTaxs(state, taxs) {
    state.taxs = taxs;
  },
  setAddTaxSlice(state, taxs) {
    state.tas = taxs;
  },
  setEditTaxSlice(state, taxs) {
    state.tas = taxs;
  },
  deleteTaxSlice(state, taxs) {
    state.tas = taxs;
  },
  setTaxErrors(state, errors) {
    state.errors = errors;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
